import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {BarLoader, BeatLoader, BounceLoader, CircleLoader, ClimbingBoxLoader, ClipLoader, ClockLoader, DotLoader, FadeLoader, GridLoader, HashLoader, MoonLoader, PacmanLoader, PropagateLoader, PuffLoader, PulseLoader, RingLoader, RiseLoader, RotateLoader, ScaleLoader, SkewLoader, SquareLoader, SyncLoader } from 'react-spinners';
import logo from "../assets/cara.png";
import "./testimoniallogo.css" 
import LoadingLogo from './LoadingLogo';
const Testimonial = ({ id, name, title, image, quote, fetchTestimonials }) => {
  const handleDelete = (postId) => {
    console.log(`Delete button clicked for testimonial ${postId}`);
    const token = localStorage.getItem('token');
    const headers = {
      Authorization: `token ${token}`,
    };


    // useEffect(() => {
    //   if (window.performance.navigation.type === PerformanceNavigation.TYPE_RELOAD) {
    //     window.location.href = '/';
    //   }
    // }, []);
  

    axios
      .delete(`https://apifusion.synergyindustri.com/api/testimonial/${postId}/delete/`, { headers })
      .then((response) => {
        console.log('Testimonial post deleted successfully:', response.data);
        // Handle successful delete
        fetchTestimonials();
      })
      .catch((error) => {
        console.error('Error deleting testimonial post:', error);
      });
  };

  const handleEdit = (postId) => {
    console.log(`Change picture clicked for blog post ${postId}`);
    const handleImageChange = (event) => {
      const imageFile = event.target.files[0];
      if (imageFile) {
        const title = prompt('Enter the new title:');
        const quote = prompt('Enter the new quote:');
        const name = prompt('Enter the new name:');
        if (title && quote && name) {
          const formData = new FormData();
          formData.append('image', imageFile);
          formData.append('title', title);
          formData.append('quote', quote);
          formData.append('name', name);

          const token = localStorage.getItem('token');
          const headers = {
            Authorization: `token ${token}`,
          };

          // Debug: enumerate FormData entries before sending update
          try {
            for (const entry of formData.entries()) {
              console.log('FormData (update) entry:', entry[0], entry[1]);
            }
          } catch (e) {
            console.warn('Could not enumerate FormData entries (update):', e);
          }

          axios
            .put(`https://apifusion.synergyindustri.com/api/testimonial/${postId}/`, formData, { headers })
            .then((response) => {
              console.log('Image changed successfully:', response.data);
              fetchTestimonials(); // Refresh the testimonial list
            })
            .catch((error) => {
              console.error('Error changing image (multipart):', error);
              console.error('Error response data (update):', JSON.stringify(error.response?.data));
              const imageFieldErrors = error.response?.data?.image;
              const shouldFallback = Array.isArray(imageFieldErrors) && imageFieldErrors.some(msg => String(msg).toLowerCase().includes('not a valid string'));
              if (shouldFallback) {
                console.log('Server expects base64 string for update; retrying with base64 JSON payload');
                const reader2 = new FileReader();
                reader2.onload = (e2) => {
                  const base64Image2 = e2.target.result;
                  const jsonHeaders2 = {
                    Authorization: `token ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json',
                  };
                  axios
                    .put(`https://apifusion.synergyindustri.com/api/testimonial/${postId}/`, { image: base64Image2, title, quote, name }, { headers: jsonHeaders2 })
                    .then((res3) => {
                      console.log('Image updated successfully via base64 fallback:', res3.data);
                      fetchTestimonials();
                    })
                    .catch((err3) => {
                      console.error('Fallback base64 update also failed:', err3, err3.response?.data);
                      try { alert('Error updating testimonial (fallback): ' + JSON.stringify(err3.response?.data || err3.message)); } catch (e) {}
                    });
                };
                reader2.readAsDataURL(imageFile);
                return;
              }
              try { alert('Error updating testimonial: ' + JSON.stringify(error.response?.data || error.message)); } catch (e) {}
            });
        }
      }
    };

    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.accept = 'image/*';
    inputElement.addEventListener('change', handleImageChange);
    inputElement.click();
  };

  const isLoggedIn = !!(
    localStorage.getItem('token') && localStorage.getItem('user')
  );

  return (
    <div className="flex items-center justify-center bg-gray-100 py-8 px-4 sm:px-6 lg:px-8 ">
      <div className="max-w-3xl w-full mx-auto">
        <div className="bg-white shadow-lg rounded-lg overflow-hidden hover:bg-gray-200 hover:cursor-pointer">
          <div className="flex justify-center">
            <img className="h-36 w-36 rounded-full mt-2" src={image} alt={name} />
          </div>
          <div className="px-6 py-4">
            <h3 className="text-xl font-semibold text-gray-800">{name}</h3>
            <p className="text-gray-600 text-sm">{title}</p>
            <blockquote className="mt-4 text-lg text-gray-800 text-justify">"{quote}"</blockquote>
          </div>

          {isLoggedIn && (
            <div className="flex justify-between items-center px-6 py-2">
              <button
                className="text-white hover:bg-blue-800 mr-2 bg-blue-600 rounded-lg px-4 py-1"
                onClick={() => handleEdit(id)}
              >
                Edit
              </button>
              <button
                className="text-white hover:bg-red-800 mr-2 bg-red-600 rounded-lg px-4 py-1"
                onClick={() => handleDelete(id)}
              >
                Delete
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const TestimonialSection = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchTestimonials = () => {
    axios
      .get('https://apifusion.synergyindustri.com/api/testimonials-getall/')
      .then((response) => {
        setTestimonials(response.data);
        setIsLoading(false); // Set loading state to false when data is fetched
      })
      .catch((error) => {
        console.error('Error fetching testimonials:', error);
        setIsLoading(false); // Set loading state to false even if there's an error
      });
  };

  useEffect(() => {
    fetchTestimonials();
  }, []);



useEffect(() => {
    if (window.performance.navigation.type === PerformanceNavigation.TYPE_RELOAD) {
      window.location.href = '/';
    }
  }, []);
  
  const handleAddImage = () => {
    const handleImageChange = (event) => {
      const imageFile = event.target.files[0];
      if (imageFile) {
        const title = prompt('Enter the title:');
        const quote = prompt('Enter the description:');
        const name = prompt('Enter the name:');
        if (title && quote && name) {
          const formData = new FormData();
          formData.append('image', imageFile);
          formData.append('title', title);
          formData.append('name', name);
          formData.append('quote', quote);

          const token = localStorage.getItem('token');
          const headers = {
            Authorization: `token ${token}`,
          };
          // Debug: enumerate FormData entries before sending
          try {
            for (const entry of formData.entries()) {
              console.log('FormData entry:', entry[0], entry[1]);
            }
          } catch (e) {
            console.warn('Could not enumerate FormData entries:', e);
          }

          axios
            .post('https://apifusion.synergyindustri.com/api/testimonials/create/', formData, { headers })
            .then((response) => {
              console.log('Image added successfully:', response.data);
              fetchTestimonials(); // Refresh the testimonial list
            })
            .catch((error) => {
              console.error('Error adding image (multipart):', error);
              console.error('Error response data:', JSON.stringify(error.response?.data));
              const imageFieldErrors = error.response?.data?.image;
              const shouldFallback = Array.isArray(imageFieldErrors) && imageFieldErrors.some(msg => String(msg).toLowerCase().includes('not a valid string'));
              if (shouldFallback) {
                console.log('Server expects base64 string; retrying with base64 JSON payload');
                const reader = new FileReader();
                reader.onload = (e) => {
                  const base64Image = e.target.result;
                  const jsonHeaders = {
                    Authorization: `token ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json',
                  };
                  axios
                    .post('https://apifusion.synergyindustri.com/api/testimonials/create/', { image: base64Image, title, name, quote }, { headers: jsonHeaders })
                    .then((res2) => {
                      console.log('Image added successfully via base64 fallback:', res2.data);
                      fetchTestimonials();
                    })
                    .catch((err2) => {
                      console.error('Fallback base64 create also failed:', err2, err2.response?.data);
                      try { alert('Error adding testimonial (fallback): ' + JSON.stringify(err2.response?.data || err2.message)); } catch (e) {}
                    });
                };
                reader.readAsDataURL(imageFile);
                return;
              }
              try { alert('Error adding testimonial: ' + JSON.stringify(error.response?.data || error.message)); } catch (e) {}
            });
        }
      }
    };
  
    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.accept = 'image/*';
    inputElement.addEventListener('change', handleImageChange);
    inputElement.click();
  };

  const isLoggedIn = !!(
    localStorage.getItem('token') && localStorage.getItem('user')
  );

  return (
    <div>
    <h1 className="text-4xl font-bold my-8 flex flex-row intem-center justify-center">Testimonials</h1>
      <div>
        {isLoading ? (
// dd

<LoadingLogo />
        ) : (
          testimonials.map((testimonial, index) => (
            <Testimonial
              key={index}
              id={testimonial.id}
              name={testimonial.name}
              title={testimonial.title}
              image={testimonial.image}
              quote={testimonial.quote}
              fetchTestimonials={fetchTestimonials}
            />
          ))
        )}
      </div>

      {isLoggedIn && (
        <div className="flex justify-center items-center">
          <button
            className="text-white hover:bg-green-800 bg-green-600 rounded-lg px-4 py-2 mt-4"
            onClick={handleAddImage}
          >
            Add Testimonial
          </button>
        </div>
      )}
    </div>
  );
};

export default TestimonialSection;